import React, { useEffect, useState } from "react";

// Material-UI
import Dialog from "@material-ui/core/Dialog";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

// Styles
import useStyles from "./style";

import { useData } from "../../../components/firebase/DataProvider";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import {
  Avatar,
  Button,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";

function CalonDialog({ open, handleClose }) {
  const classes = useStyles();
  const { profil } = useData();
  const title =
    profil.tipe_akun === "agen"
      ? "Calon Reseller"
      : profil.tipe_akun === "distributor"
      ? "Calon Agen"
      : "Calon Distributor";
  const { subdomain } = useData();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getlistpendaftar");

      const res = await func({ domain: subdomain?.id });

      setData(res?.data ?? []);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  // console.log(data);

  function pad2(n) {
    return (n < 10 ? "0" : "") + n;
  }

  const handleWa = (no, nama) => {
    const text = `halo kak ${nama}, apa masih punya pertanyaan terkait registrasi di tokorame?`;

    window.open(`https://wa.me/?text=${text}&phone=${no?.replace("+", "")}`);
  };

  if (loading) {
    return (
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "3%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginLeft: "1.5%",
              width: "60%",
            }}
          >
            <Avatar className={classes.medium}>
              <Skeleton
                variant="circle"
                style={{
                  width: 50,
                  height: 50,
                }}
              />
            </Avatar>
            <div style={{ marginLeft: "1.5%", width: "200px" }}>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" />
              </div>
              <div style={{ width: "100%" }}>
                <Skeleton variant="text" />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "40%",
              // marginRight: "1,5%",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100px", marginRight: "5%" }}>
              <Skeleton variant="text" />
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            marginTop: "3%",
          }}
        >
          <div
            style={{
              display: "flex",
              marginLeft: "1.5%",
              width: "60%",
            }}
          >
            <Avatar className={classes.medium}>
              <Skeleton
                variant="circle"
                style={{
                  width: 50,
                  height: 50,
                }}
              />
            </Avatar>
            <div style={{ marginLeft: "1.5%", width: "200px" }}>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" />
              </div>
              <div style={{ width: "100%" }}>
                <Skeleton variant="text" />
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "40%",
              // marginRight: "1,5%",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ width: "100px", marginRight: "5%" }}>
              <Skeleton variant="text" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (data?.length < 1) {
    return (
      <Typography
        style={{
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          marginTop: "2.5%",
          fontWeight: "bold",
        }}
      >
        Tidak Ada Data
      </Typography>
    );
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title"
      fullScreen
      PaperProps={{
        style: { maxWidth: 960 },
      }}
    >
      <DialogTitle>
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            onClick={handleClose}
            style={{ marginRight: 15 }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography>{title}</Typography>
        </div>
      </DialogTitle>
      <DialogContent dividers style={{ padding: 10 }}>
        {/* <List> */}
        {data &&
          data
            ?.sort((a, b) => {
              const x = a?.transaction_time;
              const y = b?.transaction_time;
              if (x > y) {
                return -1;
              }
              if (y > x) {
                return 1;
              }
              return 0;
            })
            ?.map((item, index) => {
              const tgl = item?.transaction_time;
              const dates = new Date(tgl?._seconds * 1000);
              const newCreated_at = `${dates.getFullYear()}-${pad2(
                dates.getMonth() + 1
              )}-${pad2(dates.getDate())}`;

              const newDate = `${new Date().getFullYear()}-${pad2(
                new Date().getMonth() + 1
              )}-${pad2(new Date().getDate())}`;

              return (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    marginTop: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      // marginLeft: "1.5%",
                      width: "50%",
                    }}
                  >
                    <Avatar className={classes.medium}>
                      <AccountCircleIcon style={{ width: 40, height: 40 }} />
                    </Avatar>
                    <div style={{ marginLeft: "1.5%" }}>
                      <div style={{ display: "flex" }}>
                        <div style={{ display: "inline-grid" }}>
                          <Typography
                            noWrap={true}
                            style={{
                              fontSize: 15,
                              fontWeight: "bold",
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.nama}
                          </Typography>
                        </div>
                        {/* <div
                            style={{
                              backgroundColor: "#FED0E0",
                              borderRadius: 4,
                              marginLeft: 8,
                              justifyContent: "center",
                            }}
                          >
                            <text
                              style={{
                                fontSize: 12,
                                fontWeight: "bold",
                                margin: "3px",
                                fontVariant: "small-caps",
                                color: "#f44336",
                              }}
                            >
                              {item?.tipe_akun}
                            </text>
                          </div> */}
                      </div>
                      <div>
                        <Typography style={{ fontSize: 13 }}>
                          {tgl ? newCreated_at : "-"}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "50%",
                      // marginRight: "1,5%",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div style={{ display: "inline-grid" }}>
                      <Button
                        style={{ marginLeft: "10px" }}
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => {
                          handleWa(item.wa, item?.nama);
                        }}
                      >
                        <Typography noWrap={true} variant="button">
                          CHAT {item.wa}{" "}
                        </Typography>
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
        {/* </List>{" "} */}
      </DialogContent>
    </Dialog>
  );
}

export default CalonDialog;
